<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='23'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div style="width:100%;height:30px;padding-top: 5px;">
            <el-button type="primary" size="mini" round plain @click="Createtask()">添加出库信息</el-button>
            <el-button type="primary" size="mini" round plain @click="Export()" icon="el-icon-download">出库信息导出</el-button>
            <div style="float: right;">
              <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible = true"></i>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row class="rukustyle1">
              <el-col :span="4">
                <div class="grid-content1 bg-purple">出库单数</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content1 bg-purple">出库产品数量</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content1 bg-purple">出库产品价格</div>
              </el-col>
              <el-col :span="5">
                <el-date-picker
                  v-model="addtimeBTTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectOperationTime"
                  size="small"
                  style="width: 100%;"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="5" style="margin-left: 10px;">
                <el-input size="small" v-model="listQuery.search" clearable placeholder="请输入名称、规格" class="filter-item">
                  <el-button slot="append" @click="search">搜索</el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-row class="rukustyle2">
              <el-col :span="4">
                <div class="grid-content2 bg-purple">
                  <count-to :start-val="0" :end-val="num_out_order" :duration="2600" :decimals="0" class="card-panel-num" style="font-size:16px;" />
                  <span>单</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content2 bg-purple">
                  <count-to :start-val="0" :end-val="num_out_product" :duration="2600" :decimals="0" class="card-panel-num" style="font-size:16px;" />
                  <span>件</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content2 bg-purple">
                  <count-to :start-val="0" :end-val="price_out_product" :duration="2600" :decimals="3" class="card-panel-num" style="font-size:16px;" />
                  <span>元</span>
                </div>
              </el-col>
              <el-col :span="5" style="margin-top: 4px;">
                <el-select v-model="listQuery.outbound_type" placeholder="出库类型" clearable @change="selectOperationTime" size="small" style="width: 100%;">
                  <el-option label="销售出库" value="1"></el-option>
                  <el-option label="调拨出库" value="2"></el-option>
                </el-select>
              </el-col>
              <el-col :span="5" style="margin-top: 4px;">
                <el-select v-if="current_user.id == 2 || current_user.id == 100" v-model="listQuery.user_id" placeholder="出库仓库" clearable @change="selectOperationTime" size="small" style="width: 100%">
                  <el-option
                    v-for="item in optionsUserList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="rukustyle3">
              <el-col :span="13">
                <el-cascader v-model="listQuery.storage_address" :options="companyList" placeholder="入库地址" clearable @change="selectOperationTime" filterable :props="{ value: 'id',label: 'name' }" style="width: 96%;" size="small"></el-cascader>
              </el-col>
              <el-col :span="11">
                <el-select v-model="listQuery.transfer_address" placeholder="调拨地址" clearable @change="selectOperationTime" size="small" style="width: 94%;margin-left: -6px">
                  <el-option
                    v-for="item in optionsUserList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="position: static;margin-top: 8px;">
              <el-col :span="24" class="task">
                <el-table ref="singleTable" :data="list" border v-loading="qyloading" style="width: 100%">
                  <el-table-column align="center" type="selection" width="50"></el-table-column>
                  <el-table-column align="center" prop="addtime" label="日期" width="100"></el-table-column>
                  <el-table-column align="center" prop="title" label="名称"></el-table-column>
                  <el-table-column align="center" prop="specification" label="规格"></el-table-column>
                  <el-table-column align="center" prop="outbound_units" label="出库单位"></el-table-column>
                  <el-table-column align="center" prop="outbound_num" label="出库数量"></el-table-column>
                  <el-table-column align="center" prop="outbound_price" label="出库单价"></el-table-column>
                  <el-table-column align="center" prop="total_price" label="总价"></el-table-column>
                  <el-table-column align="center" label="出库类型" width="120">
                    <template slot-scope="{row}">
                      <el-select v-model="row.outbound_type" placeholder="请选择" @change="changeOutbound_type(row, 'outbound_type')" size="small">
                        <el-option label="销售出库" value="1"></el-option>
                        <el-option label="调拨出库" value="2"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="出库仓库">
                    <template slot-scope="{row}">
                      <el-select v-model="row.user_id" placeholder="请选择" @change="changeOutbound_type(row, 'user_id')" size="small">
                        <el-option
                          v-for="item in optionsUserList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="90">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该信息吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getBackupoutboundList" :pageSizes="[10, 20, 30, 40, 50]"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="出库信息编辑" :visible.sync="dialogFormVisible" width="80%" :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div v-loading="qyloading">
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">出库基本信息</div>
              </div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="出库类型">
                  <el-select v-model="formData.outbound_type" placeholder="出库类型" size="small" style="width: 100%">
                    <el-option label="销售出库" value="1"></el-option>
                    <el-option label="调拨出库" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出库仓库">
                  <el-select v-model="formData.user_id" placeholder="用户仓库" size="small" style="width: 100%">
                    <el-option
                      v-for="item in optionsUserList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col v-if="formData.outbound_type === '1'" :span="24">
                <el-form-item label="入库地址" prop="storage_address">
                  <el-cascader v-model="formData.storage_address" :options="companyList" filterable :props="{ value: 'id',label: 'name' }" style="width: 100%;" size="small"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col v-if="formData.outbound_type === '2'" :span="24">
                <el-form-item label="调拨地址" prop="transfer_address">
                  <el-select v-model="formData.transfer_address" size="small" style="width: 100%">
                    <el-option
                      v-for="item in optionsUserList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">出库产品明细</div>
              </div>
            </div>
            <el-row>
              <el-table
                ref="selectproductTable"
                :data="formData.tableData"
                border
                style="width: 100%">
                <el-table-column
                  type="selection">
                </el-table-column>
                <el-table-column
                  label="选择产品"
                  width="80px">
                  <template>
                    <el-button @click="dialogProductVisible = true" icon="el-icon-coin" size="small" style="width: 20px;display: flex;justify-content: center;" :disabled="disabled"></el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="产品名称"
                  prop="title">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.title'" :rules="rules.title" style="margin-left: -100px;margin-top: 20px;">
                      <el-input v-model="scope.row.title" size="small"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="产品规格"
                  prop="specification">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.specification" size="small"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="单位"
                  prop="outbound_units"
                  width="90px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.outbound_units'" :rules="rules.outbound_units" style="margin-left: -100px;margin-top: 20px;">
                      <el-input v-model="scope.row.outbound_units" size="small"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="当前可用库存数量"
                  width="140px">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.number" size="small" :disabled="true"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="本次出库数量"
                  prop="outbound_num"
                  width="155px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.outbound_num'" :rules="rules.outbound_num" style="margin-left: -100px;margin-top: 20px;">
                      <el-input-number v-model="scope.row.outbound_num" size="small" :min="1" :max="scope.row.number" @change="handleChange" :disabled="disabled"></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="出库仓库"
                  width="110px">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.user_id" size="small">
                      <el-option
                        v-for="item in optionsUserList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  label="出库单价/元"
                  prop="outbound_price"
                  width="100px">
                  <template slot-scope="scope">
                    <el-form-item :prop="'tableData.' + scope.$index + '.outbound_price'" :rules="rules.outbound_price" style="margin-left: -100px;margin-top: 20px;">
                      <el-input v-model="scope.row.outbound_price" size="small" @change="handleChange"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
              <el-link type="primary" @click="delMsg" icon="el-icon-minus" :disabled="disabled">删除</el-link>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="出库产品总数" label-width="100px">
                  <el-input v-model="total_number_out" size="small" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出库产品售价总额/元" label-width="150px">
                  <el-input v-model="total_price_out" size="small" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="ant-card">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">出库确认</div>
              </div>
            </div>
            <el-row>
              <el-col :span="8">
                <el-form-item label="出库时间" prop="addtime">
                  <el-date-picker type="datetime" placeholder="选择日期时间" v-model="formData.addtime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" size="small"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出库员">
                  <el-select v-model="formData.outbound_personnel" size="small" :disabled="true" style="width: 100%">
                    <el-option
                      v-for="item in optionsUserList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="库管归属部门">
                  <el-input v-model="formData.department" size="small" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBackupoutbound()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择产品" :visible.sync="dialogProductVisible" width="50%">
      <el-row style="margin-bottom: 10px;">
        <el-col :span="8">
          <el-date-picker
            v-model="Product_addtimeBTTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="Product_selectOperationTime"
            size="small"
            style="width: 100%;"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8" style="margin-left: 10px;">
          <el-input size="small" v-model="Product_listQuery.search" clearable placeholder="请输入名称、规格" class="filter-item">
            <el-button slot="append" @click="Product_search">搜索</el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-table ref="productTable" :data="Product_list" border v-loading="qyloading" style="width: 100%">
          <el-table-column align="center" type="selection" width="50"></el-table-column>
          <el-table-column align="center" prop="addtime" label="日期"></el-table-column>
          <el-table-column align="center" prop="title" label="名称"></el-table-column>
          <el-table-column align="center" prop="specification" label="规格"></el-table-column>
          <el-table-column align="center" prop="units" label="单位"></el-table-column>
          <el-table-column align="center" prop="number" label="数量"></el-table-column>
          <el-table-column align="center" prop="tax_price" label="单价"></el-table-column>
          <el-table-column align="center" prop="total_price" label="总价"></el-table-column>
          <el-table-column align="center" prop="remark" label="备注"></el-table-column>
        </el-table>
        <pagination v-show="Product_total>0" :total="Product_total" :page.sync="Product_listQuery.page" :limit.sync="Product_listQuery.limit" @pagination="getBackupWarehouseList" :pageSizes="[8, 10, 20, 30, 50]"/>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogProductVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectProduct()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="出库信息EXCEl上传" :visible.sync="dialogOrderVisible" width="20%">
      <el-form :model="formOrderData" :rules="ruless" ref="FormOrder" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="上传文件" prop="filename">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="false"
                :limit="1">
                <el-button slot="trigger" size="small" type="primary">上传模板文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="importBackupWar()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="出库管理说明" :visible.sync="dialogVisible" width="50%">
      <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="700px">
        <el-carousel-item v-for="(item,index) in srcList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/backupOutbound'
import busOrders from '@/api/businessOrders'
import expense from '@/api/expense'
import backupWarehouse from '@/api/backupWarehouse'
import { getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import CountTo from 'vue-count-to'

export default {
  name: 'backupOutbound',
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_backup_warehouse',
      requestHeaders: {
        'X-Token': getToken()
      },
      qyloading: false,
      fileList: [],
      listQuery: {
        limit: 10,
        order: 'addtime',
        page: 1,
        sort: 'DESC'
      },
      dialogFormVisible: false,
      dialogOrderVisible: false,
      locktype: false,
      companyList: [],
      formData: {
        id: null,
        outbound_type: '1',
        user_id: null,
        storage_address: [],
        transfer_address: '',
        tableData: [
          {
            id: null,
            warehouse_id: null,
            title: '',
            specification: '',
            outbound_units: '',
            number: 0,
            outbound_num: 0,
            user_id: null,
            outbound_price: ''
          }
        ],
        addtime: new Date(),
        outbound_personnel: null,
        department: '志鹏供应链（内蒙古）有限公司'
      },
      total_number_out: 0,
      total_price_out: 0,
      formOrderData: {
        filename: ''
      },
      rules: {
        storage_address: [{ required: true, message: '请选择入库地址', trigger: 'blur' }],
        transfer_address: [{ required: true, message: '请选择调拨地址', trigger: 'blur' }],
        title: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        outbound_units: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        outbound_num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        outbound_price: [{ required: true, message: '请输入单价', trigger: 'blur' }]
      }, // 上传订单
      ruless: {
        filename: [{ required: true, message: '请上传模板文件', trigger: 'change' }]
      },
      visible: false,
      dialogVisible: false,
      srcList: [
        'https://serv.nmzp.com/uploads/1/image/20240422/6687fd0195ca2376df44e5d3201a79b3.png',
        'https://serv.nmzp.com/uploads/1/image/20240422/edd1ff9871497b4d7cf9514d4211d323.png'
      ],
      primary_key: 'product_id',
      addtimeBTTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      optionsUserList: [],
      num_out_order: 0,
      num_out_product: 0,
      price_out_product: 0,
      goodsMessage: [],
      dialogProductVisible: false,
      Product_list: [],
      Product_total: 0,
      Product_listQuery: {
        limit: 8,
        order: 'addtime',
        page: 1,
        sort: 'DESC'
      },
      Product_addtimeBTTime: [],
      disabled: false
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getBackupoutboundList()
    this.getUserList()
    this.getCompanyList()
    this.getBackupWarehouseList()
  },
  methods: {
    getBackupoutboundList () {
      this.qyloading = true
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      api.getBackupoutboundList(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        this.num_out_order = response.data.total
        this.num_out_product = Number(response.data.num_out_product)
        this.price_out_product = Number(response.data.price_out_product)
        this.qyloading = false
      })
    },
    downloadht () {
      window.open('https://serv.nmzp.com/uploads/doexcel/NMZPBACKUP.xlsx')
    },
    Createtask () {
      this.dialogFormVisible = true
      this.disabled = false
      this.formData = {
        id: null,
        outbound_type: '1',
        user_id: this.current_user.id,
        storage_address: [],
        transfer_address: '',
        tableData: [
          {
            id: null,
            warehouse_id: null,
            title: '',
            specification: '',
            outbound_units: '',
            number: 0,
            outbound_num: 0,
            user_id: null,
            outbound_price: ''
          }
        ],
        addtime: new Date(),
        outbound_personnel: this.current_user.id,
        department: '志鹏供应链（内蒙古）有限公司'
      }
      this.total_number_out = 0
      this.total_price_out = 0
    },
    Uploadorder () {
      this.dialogOrderVisible = true
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.disabled = true
      api.getDetail({ id: row.id }).then(response => {
        if (response.code === 20000) {
          this.formData = response.items
          this.cal_price()
        } else {
          this.$message.error(response.message)
        }
      })
    },
    handlesuccess (response, file) {
      this.subloading = false
      if (response.code === 20000) {
        // this.formData.filename = response.message
        this.formOrderData.filename = response.savename
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      this.subloading = true
      return (extension || extension2) && isLt2M
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.product_id, order_outbound_id: row.id, warehouse_id: row.warehouse_id, outbound_num: row.outbound_num }).then(response => {
        this.getBackupoutboundList()
        this.getBackupWarehouseList()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    search () {
      this.listQuery.page = 1
      this.getBackupoutboundList()
    },
    // 批量导出
    Export () {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        api.export({id: ids}).then(response => {
          if (response.code === 20000) {
            window.open(response.savename)
          } else if (response.code === 30000) {
            this.$message.error(response.message)
          } else {
            this.$message.error('导出错误')
          }
        })
      } else {
        this.$message({ message: '请选择要导出的数据', type: 'error' })
      }
    },
    copyText (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        // 尝试执行复制操作
        const success = document.execCommand('copy')
        if (success) {
          this.$message({ message: '复制成功', type: 'success' })
        } else {
          this.$message({ message: '复制失败', type: 'error' })
        }
      } catch (error) {
        this.$message({ message: error, type: 'error' })
      }
      document.body.removeChild(textarea)
    },
    getUserList () {
      busOrders.getUserList({MAccountRole: '1, 5'}).then(response => {
        this.optionsUserList = response.data
      })
    },
    selectOperationTime () {
      this.listQuery.page = 1
      if (this.addtimeBTTime) {
        this.listQuery.operationBTTime = this.addtimeBTTime
      } else {
        this.listQuery.operationBTTime = []
      }
      this.getBackupoutboundList()
    },
    getCompanyList () {
      expense.getCompanyList().then(response => {
        this.companyList = response.message
      })
    },
    addMsg (index) {
      this.formData.tableData.push({
        id: null,
        warehouse_id: null,
        title: '',
        specification: '',
        outbound_units: '',
        number: 0,
        outbound_num: 0,
        user_id: null,
        outbound_price: ''
      })
    },
    delMsg (index) {
      if (this.$refs.selectproductTable.selection.length > 0) {
        var selectProduct = this.$refs.selectproductTable.selection
        for (var j = 0; j < selectProduct.length; j++) {
          for (var i = 0; i < this.formData.tableData.length; i++) {
            if (this.formData.tableData[i]['warehouse_id'] === selectProduct[j]['warehouse_id']) {
              this.formData.tableData.splice(i, 1)
            }
          }
        }
        if (this.formData.tableData.length === 0) {
          this.addMsg()
        }
        this.cal_price()
        this.dialogProductVisible = false
      } else {
        this.$message({ message: '请选择数据', type: 'error' })
      }
    },
    getBackupWarehouseList () {
      this.qyloading = true
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.Product_listQuery.user_id = this.current_user.id
      }
      backupWarehouse.getBackupWarehouseList(this.Product_listQuery).then(response => {
        this.Product_list = response.data.items
        this.Product_total = response.data.total
        this.qyloading = false
      })
    },
    Product_selectOperationTime () {
      this.Product_listQuery.page = 1
      if (this.Product_addtimeBTTime) {
        this.Product_listQuery.operationBTTime = this.Product_addtimeBTTime
      } else {
        this.Product_listQuery.operationBTTime = []
      }
      this.getBackupWarehouseList()
    },
    Product_search () {
      this.Product_listQuery.page = 1
      this.getBackupWarehouseList()
    },
    selectProduct () {
      if (this.$refs.productTable.selection.length > 0) {
        var selectProduct = this.$refs.productTable.selection
        for (var i = 0; i < selectProduct.length; i++) {
          this.formData.tableData.push({
            id: null,
            warehouse_id: selectProduct[i]['id'],
            title: selectProduct[i]['title'],
            specification: selectProduct[i]['specification'],
            number: selectProduct[i]['number'],
            user_id: selectProduct[i]['user_id'],
            outbound_num: 1,
            outbound_units: selectProduct[i]['units'],
            outbound_price: selectProduct[i]['tax_price']
          })
        }
        for (var x = 0; x < this.formData.tableData.length; x++) {
          if (!this.formData.tableData[x]['title'] || this.formData.tableData[x]['title'] === '') {
            this.formData.tableData.splice(x, 1)
          }
        }
        this.cal_price()
        this.dialogProductVisible = false
      } else {
        this.$message({ message: '请选择数据', type: 'error' })
      }
    },
    cal_price () {
      this.total_number_out = 0
      this.total_price_out = 0
      for (var x = 0; x < this.formData.tableData.length; x++) {
        this.total_number_out += this.formData.tableData[x]['outbound_num']
        this.total_price_out += this.formData.tableData[x]['outbound_num'] * this.formData.tableData[x]['outbound_price']
      }
    },
    handleChange () {
      this.cal_price()
    },
    saveBackupoutbound () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            // return false
          }
          this.locktype = true
          // this.formData.user_id = this.current_user.id
          api.saveBackupoutbound(this.formData).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.getBackupoutboundList()
            this.getBackupWarehouseList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    changeOutbound_type (row, fieldName) {
      const params = { id: row.id }
      params[fieldName] = row[fieldName]
      api.changeOutbound_type(params).then(res => {
        if (res.code === 20000) {
          this.getBackupoutboundList()
          this.$message({ message: '操作成功', type: 'success' })
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 86%;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: 40px;
  padding: 0 24px;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background: 0 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  background: #f8faff;
}
.ant-card-head-title {
  color: #1890ff;
  padding-top: 10px;
  float: left;
}
.ant-card-head-button {
  width: 90%;
  padding-top: 5px;
  float: left;
}
.filter-container {
  text-align: right;
  display: inline-block;
  float: right;
}
.highlight{
  background-color: #f0f0f0;
}
.el-popper{
  width:600px !important;
}
.ant-card-bottom{
  border-bottom: 2px solid #f0f0f0;
}
.rukustyle1 {
  margin-left: -10px;
}
.rukustyle2 {
  margin-left: -10px;
}
.rukustyle1 .el-col {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin-left: 10px;
}
.rukustyle2 .el-col {
  color: #ffffff;
  text-align: center;
  margin-left: 10px;
}
.rukustyle2 span {
  font-size: 14px;
}
.rukustyle3 .el-col {
  color: #ffffff;
  text-align: center;
  margin-top: 10px;
  margin-left: -15px;
}
.bg-purple {
  background: #436aa6;
}
.grid-content1 {
  padding-top: 5px;
  border-radius: 4px 4px 0 0;
  min-height: 35px;
}
.grid-content2 {
  border-radius: 0 0 4px 4px;
  min-height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/view/member/backupOutbound.vue